module.exports = __webpack_public_path__ + "img/u234.99b684db.svg";